import angular from 'angular';
import _ from 'lodash';
import shuffleUtility from 'knuth-shuffle';
var shuffler = shuffleUtility.knuthShuffle;

var app = angular.module('underwraps');

app.run([
  '$httpBackend',
  function ($httpBackend) {
    // $httpBackend.whenGET('/api/settings').respond([
    //     {id: 1, name: 'setting1', value: 'value1'},
    //     {id: 2, name: 'setting2', value: 'value2'}
    // ]);

    // var gifts = [
    //     {id: 1, name: 'Salted peanuts', description: 'I will need to decide how long this should be', bought: false, price: 5},
    //     {id: 2, name: 'Hiking boots', description: 'I will need to decide how long this should be', bought: false, price: 50},
    //     {id: 3, name: 'Camelbak water bottle', description: 'I will need to decide how long this should be', bought: false, price: 15},
    //     {id: 4, name: 'Popcorn', description: 'I will need to decide how long this should be', bought: false, boughtBy: 1, price: 10},
    //     {id: 5, name: 'Mason jars', description: 'I will need to decide how long this should be', bought: false, boughtBy: 1, price: 7},
    //     {id: 6, name: 'This tshirt', description: 'I will need to decide how long this should be', bought: false, boughtBy: 1, price: 21},
    //     {id: 7, name: 'Yamaha keyboard', description: 'I will need to decide how long this should be', bought: false, boughtBy: 2, price: 450},
    //     {id: 8, name: 'Cash for trip to Italy', description: 'I will need to decide how long this should be', bought: false, price: 100},
    //     {id: 9, name: 'New shoes', description: 'I will need to decide how long this should be', bought: false, price: 45},
    //     {id: 10, name: 'Nintendo 64', description: 'I will need to decide how long this should be', bought: false, price: 22},
    //
    // ];

    var giftLists = [];
    //
    // $httpBackend.whenGET(/^\/api\/gift[-]details\/\d/).respond(function(method, url, data){
    //     var parameters = url.split('/');
    //     var id = new Number(parameters[parameters.length-1]);
    //     var gift = _.find(gifts, {id: id});
    //
    //
    //     return [200, gift, {}];
    // });
    //
    // $httpBackend.whenGET(/\/api\/gift[-]list\/\d+/).respond(function(method, url, data){
    //
    //     var parameters = url.split('/');
    //     var id = new Number(parameters[parameters.length-1]);
    //
    //     if(!giftLists[id]){
    //         var shuffledGifts = shuffler(angular.copy(gifts));
    //         giftLists[id] = shuffledGifts;
    //     }
    //     return [200, giftLists[id], {}];
    // });

    // $httpBackend.whenGET('/api/friends').respond([
    //     {id: 1, name: 'Nate'},
    //     {id: 2, name: 'Jenny'},
    //     {id: 3, name: 'Mom'},
    //     {id: 4, name: 'Ruth'},
    //     {id: 5, name: 'Peter'},
    //     {id: 6, name: 'Michael'},
    //     {id: 7, name: 'Andrew'},
    // ]);

    // $httpBackend.whenGET(/api\/gift-comments\/\d+/).respond([
    //     {body: 'Nate says he likes this brand.', name: 'Jenny'},
    //     {body: 'Mom and I are thinking about getting this.', name: 'Dad'},
    //     {body: 'We decided to get someting else. Check this out: https://www.amazon.com/Harperton-Nail-Clipper-Set-Fingernail/dp/B00TKS5Y3Q/ref=sr_1_1?ie=UTF8&qid=1479610423&sr=8-1-spons&keywords=nail+clippers&psc=1', name: 'Mom'},
    //     {body: 'I like chocolate!', name: 'Ruth'},
    //     {body: 'Hi guys.', name: 'Peter'},
    //     {body: 'Check out my new video! It\'s cool.', name: 'Michael'},
    //     {body: 'I decided to buy all the things for Nate.', name: 'Andrew'},
    // ]);

    $httpBackend.whenGET(/^.*/).passThrough();
    $httpBackend.whenPOST(/^.*/).passThrough();
  },
]);
